import type { SelectOption } from "../../select/EnhancedSelect";

export {
  TICKET_PRIORITY_OPTIONS,
  TICKET_CATEGORY_OPTIONS,
  TICKET_STATUS_OPTIONS,
} from "@/features/tickets/config/options";

export type { SelectOption };
